import { useQueryClient } from '@tanstack/react-query';
import { useGetOrderById } from '../../../../services/modules/order/order.queries';
import signedContractsStore from '../../../../stores/SignedContracts/SignedContracts.store';
import { Order } from '../../order.types';

const useLoadSignedContracts = (orderId: string) => {
  const { queryKey } = useGetOrderById({ enabled: false, id: orderId });
  const queryClient = useQueryClient();

  const loadSignedContracts = async () => {
    await signedContractsStore.loadSignedContracts(orderId);
    queryClient.setQueryData<Order>(queryKey, (oldData) => {
      if (!oldData) {
        return oldData;
      }

      return { ...oldData, signedContracts: signedContractsStore.signedContracts };
    });
  };

  return { loadSignedContracts };
};

export default useLoadSignedContracts;
